// extracted by mini-css-extract-plugin
var _1 = "AnimatedBurger_activeX__em7I2";
var _2 = "AnimatedBurger_nonactiveX__y-KBW";
export { _1 as "activeX", _2 as "nonactiveX" }
